import Logo from "@/components/Logo";
import { CONTACT, scrollToSection } from "@/lib/site";

export default function Footer() {
    return (
        <footer className="bg-moss-900 pt-16 pb-8 text-sand-50">
            <div className="mx-auto max-w-7xl px-5 lg:px-8">
                <div className="flex flex-col gap-10 border-b border-sand-50/10 pb-12 md:flex-row md:items-start md:justify-between">
                    <div className="max-w-sm">
                        <div className="flex items-center gap-3">
                            <Logo size={40} />
                            <span className="font-serif text-2xl font-semibold" data-testid="footer-brand-title">
                                Freelance T
                            </span>
                        </div>
                        <p className="mt-4 font-serif text-lg italic text-sand-50/70">
                            Crisiszorg met rust, aandacht en respect.
                        </p>
                    </div>

                    <div className="flex gap-16">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sand-50/50">
                                Navigatie
                            </p>
                            <ul className="mt-4 space-y-2.5 text-sm">
                                {[
                                    ["Over mij", "#over-mij"],
                                    ["Diensten", "#diensten"],
                                    ["Gratis intake", "#intake"],
                                    ["Contact", "#contact"],
                                ].map(([label, hash]) => (
                                    <li key={hash}>
                                        <a
                                            href={hash}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                scrollToSection(hash);
                                            }}
                                            className="text-sand-50/75 transition-colors hover:text-terracotta"
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sand-50/50">
                                Contact
                            </p>
                            <ul className="mt-4 space-y-2.5 text-sm">
                                <li>
                                    <a
                                        href={`mailto:${CONTACT.email}`}
                                        data-testid="footer-link-email"
                                        className="text-sand-50/75 transition-colors hover:text-terracotta"
                                    >
                                        {CONTACT.email}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={CONTACT.phoneHref}
                                        data-testid="footer-link-phone"
                                        className="text-sand-50/75 transition-colors hover:text-terracotta"
                                    >
                                        {CONTACT.phoneDisplay}
                                    </a>
                                </li>
                                <li className="text-sand-50/50">Landelijk inzetbaar</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col items-center justify-between gap-3 pt-8 text-xs text-sand-50/45 sm:flex-row">
                    <p>© 2026 Freelance T. Alle rechten voorbehouden. Zelfstandig begeleider (ZZP).</p>
                    <p>KvK geregistreerd zorgverlener</p>
                </div>
            </div>
        </footer>
    );
}
